// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-header-action-edit-recipe' )
export class AutomatorLogHeaderActionEditRecipe extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// The link to edit the recipe
	@property( { type: String, attribute: 'recipe-edit-url' } ) accessor recipeEditURL;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				<span class="tooltip-nowrap">${ escapeHTML( __( 'Edit recipe', 'uncanny-automator' ) ) }</span>

				<uo-button
					slot="target"
					color="transparent"
					size="small"

					target="_blank"
					href="${ this.recipeEditURL }"
				>
					<uo-icon id="pencil" size="16"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}
}